import { Injectable } from '@angular/core';
import { DataGridColumns } from '@app/shared/models';
import { Observable } from 'rxjs';
import { environment } from '@app/environment';
import { IPermitSearch, IPermit } from '@shared/interfaces/index';
import { Dialogs, IDataGridDialogOptions } from '@m27/common';
import { Http } from '@core/http/http';
import { IPermitKey, IPermitDates, IPermitDate } from '@permitting/interfaces/permit';
import { map } from 'rxjs/operators';
import * as moment_ from 'moment';
const moment = moment_;

@Injectable({
    providedIn: 'root'
})
export class PermitService {
    constructor(private http: Http) { }

    public Search(criteria: IPermitSearch): Observable<IPermit[]> {
        return this.http.post(`${environment.apiRoot}api/v1/Permits/Search`, criteria);
    }

    public GetKey(permitId: number): Observable<IPermitKey> {
        return this.http.get(`${environment.apiRoot}api/v1/Permits/Get/Key/${permitId}`);            
    }

    public GetDates(permitId: number): Observable<IPermitDates> {
        return this.http.get(`${environment.apiRoot}api/v1/Permits/Get/Dates/${permitId}`)
            .pipe(map((permit: IPermitDates) => {
                permit.Dates.forEach((value: IPermitDate) => {
                    if (value.LastUpdatedDate !== null && value.LastUpdatedDate !== undefined) {
                        value.LastUpdatedDate = moment(new Date(value.LastUpdatedDate)).format('MM/DD/YYYY');
                    }
                    if (value.Date !== null && value.Date !== undefined) {
                        value.Date = new Date(value.Date);
                    }                    
                });

                return permit;
            }));
    }

    public ShowPermitDialog(title: string, permitIds: number[]): void {
        Dialogs.DataGrid.open({
            Title: title,
            Data: this.Search({ PermitIds: permitIds } as IPermitSearch),
            ColDefs: DataGridColumns.PermitSearchResults(),
            Width: 1123,
            Height: 400,
            LoadingMessage: 'Loading Permits...'
        } as IDataGridDialogOptions);
    }
}
